import { render } from "./It.vue?vue&type=template&id=26a16e6e"
import script from "./It.vue?vue&type=script&lang=js"
export * from "./It.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-archive/__GITLAB/archive-collections/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__